import { graphql } from 'gql.tada';
import { useMutation } from '@apollo/client';

const MakeSchoolYearCurrentMutation = graphql.persisted(
  'MakeSchoolYearCurrent',
  graphql(`
    mutation MakeSchoolYearCurrent($schoolYearId: ID!) {
      makeSchoolYearCurrent(input: { schoolYearId: $schoolYearId }) {
        schoolYear {
          id
          state
        }
        userErrors {
          message
          path
        }
      }
    }
  `)
);

export { MakeSchoolYearCurrentMutation };

export function useMakeSchoolYearCurrent() {
  return useMutation(MakeSchoolYearCurrentMutation);
}
